import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'


import globalMU from "globalMU"

declare var window:any

export type DefinirValorServicosAgregadosInput = {
    valorServicosAgregados: number
}

export async function definirValorServicosAgregados(input: DefinirValorServicosAgregadosInput) {
    
    try {
        globalMU.blockUI()
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirValorServicosAgregados(
            store.getState().orcamento.IdentificadorOrcamento,
            input.valorServicosAgregados
        )
    
        
    
        const atualizarEstado = () => {
            const orcamentoLegado = window.orcamentoController.model

            orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

            store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
        }
    
        //atualizarRedux()
        atualizarEstado()
    } finally {
        globalMU.unblockUI()
    }
}